<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ir_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="ir_custname">
            <label class="weui-form-preview__label">{{customLabel.ir_custname || "客户名称"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.ir_custname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="ir_contact">
            <label class="weui-form-preview__label">{{customLabel.ir_contact || "卖家联系人"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
            >
              {{ form.main.ir_contact }}
              {{ form.main.ir_tel }}
              <call-mobile :mobile="form.main.si_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ir_address">
            <label class="weui-form-preview__label">{{customLabel.ir_address || "交货地址"}}</label>
            <span
              class="weui-form-preview__value"
              :class="{
                'weui-form-preview__value-icon': !!form.main.ir_address,
              }"
              >{{ form.main.ir_address }}
              <router-link
                v-if="form.main.ir_address"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + form.main.ir_address"
              ></router-link>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ir_delivery">
            <label class="weui-form-preview__label">{{customLabel.ir_delivery || "交货方式"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.ir_delivery }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ir_date">
            <label class="weui-form-preview__label">{{customLabel.ir_date || "发布日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_enddate">
            <label class="weui-form-preview__label">{{customLabel.ir_enddate || "截止日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_enddate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_businesscode">
            <label class="weui-form-preview__label">{{customLabel.ir_businesscode || "商机编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_businesscode
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ird_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="ird_prodname">
              <label class="weui-form-preview__label">{{customLabel.ird_prodname || "物料名称"}}</label>
              <span class="weui-form-preview__value">
                {{ item.ird_prodname }}
                {{ item.ird_prodcode }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">
                {{ item.pr_spec }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">
                {{ item.pr_orispeccode }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="ird_custprodName">
              <label class="weui-form-preview__label">{{customLabel.ird_custprodName || "客户物料"}}</label>
              <span class="weui-form-preview__value">
                {{ item.ird_custprodName }}
                {{ item.ird_custprodcode }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="ird_price">
              <label class="weui-form-preview__label">{{customLabel.ird_price || "样品价"}}</label>
              <span class="weui-form-preview__value">
                {{ item.ird_price }}
              </span>
            </div>
            <div
              class="weui-form-preview__item" slot="ird_custprodOrispec"
              v-if="item.ird_custprodOrispec"
            >
              <label class="weui-form-preview__label">{{customLabel.ird_custprodOrispec || "客户物料型号"}}</label>
              <span class="weui-form-preview__value">
                {{ item.ird_custprodOrispec }}
              </span>
            </div>
            <div class="weui-form-preview__item" v-if="item.ird_custprodSpec" slot="ird_custprodSpec">
              <label class="weui-form-preview__label">{{customLabel.ird_custprodSpec || "客户物料规格"}}</label>
              <span class="weui-form-preview__value">
                {{ item.ird_custprodSpec }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="ird_qty">
              <label class="weui-form-preview__label">{{customLabel.ird_qty || "数量"}}</label>
              <span class="weui-form-preview__value">
                {{ item.ird_qty }}
                {{ item.ird_prodUnit }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="showData">
              <label class="weui-form-preview__label">{{customLabel.showData || "成品阶梯价"}}</label>
              <span
                class="weui-form-preview__value"
                v-for="i in item.gradientPriceDTOList"
                :key="i.gp_id"
              >
                {{ i.gp_step + "+" }}
                {{ "￥" + i.gp_price }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="ird_lead_time">
              <label class="weui-form-preview__label">{{customLabel.ird_lead_time || "供货周期"}}</label>
              <span class="weui-form-preview__value">
                {{ item.ird_lead_time }}
              </span>
            </div>
          </custom-layout>
        </div>
      </div>
      <file-list v-model="form.main.ir_attach" />
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/sample/sampleReply",
      codeField: "ir_code",
      statusField: "ir_statuscode",
      caller: "SampleInquiryReply",
      xtype: "sample-sampleReply-formpanel",
    };
  },
};
</script>